import {metadaApi} from '@dms/api/base';

import {
  GetReceiveNoteCorrectionBasketRequest,
  GetReceiveNoteCorrectionBasketRequestSchema,
  GetReceiveNoteCorrectionBasketResponse,
  GetReceiveNoteCorrectionBasketResponseSchema,
  PatchReceiveNoteCorrectionBasketItemCorrectionValueRequest,
  PatchReceiveNoteCorrectionBasketItemCorrectionValueRequestSchema,
  PatchReceiveNoteCorrectionBasketItemCorrectionValueResponse,
  PatchReceiveNoteCorrectionBasketItemCorrectionValueResponseSchema,
  PatchReceiveNoteCorrectionBasketItemQuantityRequest,
  PatchReceiveNoteCorrectionBasketItemQuantityRequestSchema,
  PatchReceiveNoteCorrectionBasketItemQuantityResponse,
  PatchReceiveNoteCorrectionBasketItemQuantityResponseSchema,
  PostReceiveNoteCorrectionBasketCheckoutRequest,
  PostReceiveNoteCorrectionBasketCheckoutRequestSchema,
  PostReceiveNoteCorrectionBasketCheckoutResponse,
  PostReceiveNoteCorrectionBasketCheckoutResponseSchema,
} from './types';

export const metadaWarehouseReceiveNoteCorrectionBasketApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getReceiveNoteCorrectionBasket: build.query<
      GetReceiveNoteCorrectionBasketResponse,
      GetReceiveNoteCorrectionBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/credit-note/${queryArg.creditNoteId}/basket`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'receiveNoteCorrectionBasket', id: queryArg.creditNoteId},
      ],
      extraOptions: {
        requestSchema: GetReceiveNoteCorrectionBasketRequestSchema,
        responseSchema: GetReceiveNoteCorrectionBasketResponseSchema,
      },
    }),
    postReceiveNoteCorrectionBasketCheckout: build.mutation<
      PostReceiveNoteCorrectionBasketCheckoutResponse,
      PostReceiveNoteCorrectionBasketCheckoutRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/credit-note/${queryArg.creditNoteId}/basket/checkout`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'receiveNoteCorrectionBasket', id: queryArg.creditNoteId},
        {type: 'receiveNoteCorrections', id: queryArg.creditNoteId},
        'headerDynamicActions',
      ],
      extraOptions: {
        requestSchema: PostReceiveNoteCorrectionBasketCheckoutRequestSchema,
        responseSchema: PostReceiveNoteCorrectionBasketCheckoutResponseSchema,
      },
    }),
    patchReceiveNoteCorrectionBasketItemQuantity: build.mutation<
      PatchReceiveNoteCorrectionBasketItemQuantityResponse,
      PatchReceiveNoteCorrectionBasketItemQuantityRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/credit-note/${queryArg.creditNoteId}/basket-item/${queryArg.creditNoteItemId}/quantity`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'receiveNoteCorrectionBasket', id: queryArg.creditNoteId},
        {type: 'receiveNoteCorrectionItems', id: queryArg.creditNoteItemId},
      ],
      extraOptions: {
        requestSchema: PatchReceiveNoteCorrectionBasketItemQuantityRequestSchema,
        responseSchema: PatchReceiveNoteCorrectionBasketItemQuantityResponseSchema,
      },
    }),
    patchReceiveNoteCorrectionBasketItemCorrectionValue: build.mutation<
      PatchReceiveNoteCorrectionBasketItemCorrectionValueResponse,
      PatchReceiveNoteCorrectionBasketItemCorrectionValueRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/credit-note/${queryArg.creditNoteId}/basket-item/${queryArg.creditNoteItemId}/correction-value`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'receiveNoteCorrectionBasket', id: queryArg.creditNoteId},
        {type: 'receiveNoteCorrectionItems', id: queryArg.creditNoteItemId},
      ],
      extraOptions: {
        requestSchema: PatchReceiveNoteCorrectionBasketItemCorrectionValueRequestSchema,
        responseSchema: PatchReceiveNoteCorrectionBasketItemCorrectionValueResponseSchema,
      },
    }),
  }),
});

export const {
  useGetReceiveNoteCorrectionBasketQuery,
  usePostReceiveNoteCorrectionBasketCheckoutMutation,
  usePatchReceiveNoteCorrectionBasketItemQuantityMutation,
  usePatchReceiveNoteCorrectionBasketItemCorrectionValueMutation,
} = metadaWarehouseReceiveNoteCorrectionBasketApi;
